// src/components/ProductDetails.js
import React from 'react';
import { Descriptions } from 'antd';

const GTIN = ({ data }) => {
  if (!data?.producto?.length) {
    return <p>No se encontró información del producto.</p>;
  }

  const producto = data.producto[0];
  const cliente = producto.cliente;
  const categoria = producto.categoria;
  const gtin14List = Array.isArray(producto.gtin14) ? producto.gtin14 : [];

  const labelWithFormat = (label, translation) => (
    <span>
      <strong>{label}</strong>{' '}
      <span style={{ color: '#fa541c' }}>({translation})</span>
    </span>
  );

  return (
    <div style={{ padding: 20 }}>
      <Descriptions
        title="Producto (Product)"
        bordered
        column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
      >
        <Descriptions.Item
          label={labelWithFormat('Código GTIN', 'Global Trade Item Number')}
        >
          {producto?.codbar}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat('Descripción del producto', 'Description')}
        >
          {producto?.despro}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Marca', 'Brand')}>
          {producto?.marca}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat('Contenido neto', 'Net content')}
        >
          {producto?.contenido}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat('Unidad de medida', 'Unit of measurement')}
        >
          {producto?.um}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat('Fecha de asignación', 'Assignment date')}
        >
          {new Date(producto?.feccre).toLocaleString()}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat('Grupo del producto', 'Product group')}
        >
          {producto?.brick}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat('Imagen del producto', 'Image')}
        >
          {producto?.foto}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat(
            'Categoría del producto mundial',
            'Categories'
          )}
        >
          {categoria?.desbrick}
        </Descriptions.Item>
      </Descriptions>

      {gtin14List.length ? (
        gtin14List.map((gtin14, index) => (
          <Descriptions
            key={gtin14?.codigo ?? index}
            title={`Unidad logística (GTIN-14) ${
              gtin14?.presentacion
                ? `- Presentación ${gtin14.presentacion}`
                : `#${index + 1}`
            }`}
            bordered
            column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
            style={{ marginTop: 20 }}
          >
            <Descriptions.Item
              label={labelWithFormat('Código GTIN-14', 'GTIN-14')}
            >
              {gtin14?.g14}
            </Descriptions.Item>
            <Descriptions.Item
              label={labelWithFormat('Presentación', 'Presentation')}
            >
              {gtin14?.presentacion}
            </Descriptions.Item>
            <Descriptions.Item label={labelWithFormat('Factor', 'Contenido')}>
              {gtin14?.unidad}
            </Descriptions.Item>
            <Descriptions.Item
              label={labelWithFormat('Descripción', 'Description')}
            >
              {gtin14?.descripcion}
            </Descriptions.Item>
          </Descriptions>
        ))
      ) : (
        <Descriptions
          title="Unidad logística (GTIN-14)"
          bordered
          column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
          style={{ marginTop: 20 }}
        >
          <Descriptions.Item
            label={labelWithFormat('Código GTIN-14', 'GTIN-14')}
          >
            No hay unidades logísticas disponibles
          </Descriptions.Item>
        </Descriptions>
      )}

      <Descriptions
        title="Empresa (Company)"
        bordered
        column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
        style={{ marginTop: 20 }}
      >
        <Descriptions.Item
          label={labelWithFormat('Nombre de la empresa', 'Company')}
        >
          {cliente?.nomcli}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat(
            'GS1 Prefijo de Empresa (GCP)',
            'Global Company Prefix'
          )}
        >
          {producto?.gln?.prefijogs1}
        </Descriptions.Item>
        <Descriptions.Item
          label={labelWithFormat('GLN', 'Global Location Number')}
        >
          {producto?.gln?.gln}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Ciudad', 'City')}>
          {producto?.ciudad?.descripcion}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Cantón', 'Canton')}>
          {producto?.canton?.descripcion}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Provincia', 'State')}>
          {producto?.provincia?.descripcion}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Email', 'Email')}>
          {cliente?.email}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Dirección', 'Address')}>
          {cliente?.dircli}
        </Descriptions.Item>
        <Descriptions.Item label={labelWithFormat('Sitio web', 'Web site')}>
          {cliente?.web}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default GTIN;
